export default "__VITE_ASSET__bqgMeA5D__"